import * as React from 'react';
import {
	Col, List, Row, Popconfirm, Tooltip, Button, Typography,
} from 'antd';
import { ListItemProps } from 'antd/lib/list';
import { INote } from '@copilot/common/store/models/redux';

interface IDeleteButtonProps {
	onDelete: () => void;
	isDeletable: boolean;
}
const DeleteButton: React.FC<IDeleteButtonProps> = (props) => {
	const { isDeletable, onDelete } = props;

	return (
		isDeletable ? (
			<Popconfirm
				title="Are you sure you want to delete this note?"
				onConfirm={() => {
					onDelete();
				}}
				okText="Yes"
				cancelText="No"
				placement="rightBottom"
			>
				<Button>
					Delete
				</Button>
			</Popconfirm>
		) : (
			<Tooltip
				placement="topRight"
				title="This note was not created by you. Please contact admin to delete the note."
				trigger="hover"
				overlayStyle={{ width: 300 }}
			>
				<Button disabled style={{ pointerEvents: 'all' }}>
					Delete
				</Button>
			</Tooltip>
		)

	);
};
export interface INoteItemProps extends ListItemProps {
	note: INote;
	removeNote: (note: any) => unknown;
	isDeletable: boolean;
}

const NoteItem: React.FC<INoteItemProps> = (props) => {
	const { note, removeNote, isDeletable } = props;
	const { message, timestamp } = note;
	const dateString = new Date(timestamp).toLocaleString();
	return (
		<List.Item className={`cmpt-module-note-item activity-item ${props.className}`}>
			<Row className="item-header" justify="space-between" align="middle">
				<Col style={{ fontSize: '12px', paddingBottom: '5px' }}>Note:</Col>
				<Col style={{ fontSize: '12px', paddingBottom: '5px' }}>{dateString}</Col>
			</Row>
			<Row className="item-content" justify="space-between">
				<Col span={20}>
					<Typography.Text>{message}</Typography.Text>
				</Col>
				<Col span={3}>
					<DeleteButton onDelete={() => removeNote(note)} isDeletable={isDeletable} />
				</Col>
			</Row>
		</List.Item>
	);
};

export default NoteItem;
